(function () {
  'use strict';

  var marker = document.getElementById('ig-shipping-protection-config');
  if (!marker || window.__igShippingProtectionLoaded) return;
  window.__igShippingProtectionLoaded = true;

  var tag = 'essential-cart-app-embed';
  var cartId = '55cfa5ad-5040-4116-a8da-aad37fcf17b2';
  var offerId = '19070006-de86-4280-8e15-fa24c7cbac15';
  var variantId = 'gid://shopify/ProductVariant/55311198814545';
  var assignment = null;
  var observer = null;
  var initialized = false;
  var configBaselines = new WeakMap();
  var choiceKey = 'ig81:5cba797a-4b20-4e03-9750-0e23164fb2aa:choice:v2';
  var selectionScheduled = false;
  var selectionTimer = null;
  var readinessChecks = 0;
  var automaticClick = false;
  var lastCart = null;
  var lastProtectionPresent = false;
  var selectionBudgetUsed = new Set();
  var restoreBudgetUsed = new Set();
  var staleSelection = null;
  var apiOperation = null;
  var autoOperation = null;
  var hiddenPrice = null;
  var inlinePriceCopy = {
    nl: 'Verzendbescherming · €2 per bestelling',
    de: 'Versandschutz · 2 € pro Bestellung',
    en: 'Shipping protection · €2 per order'
  };
  var status = window.__igShippingProtectionStatus = { variant: null, phase: 'unassigned', writes: 0, preselection: 'inactive', attempts: 0, nativeGate: 'not-checked' };
  var previewMode = false;
  var lastDiagnostic = null;
  try { previewMode = JSON.parse(marker.textContent).preview === true; } catch (_) {}

  function reportStatus() {
    if (!previewMode || !window.console || typeof window.console.info !== 'function') return;
    var diagnostic = { variant: status.variant, phase: status.phase, preselection: status.preselection, attempts: status.attempts, nativeGate: status.nativeGate };
    var serialized = JSON.stringify(diagnostic);
    if (serialized === lastDiagnostic) return;
    lastDiagnostic = serialized;
    window.console.info('[Mayson ID81] ' + serialized);
  }

  function valid(value) {
    return value === 'control' || enabledVariant(value);
  }

  function enabledVariant(value) {
    return value === 'v1' || value === 'v2';
  }

  function eligibleCart(config) {
    if (!config || !Array.isArray(config.carts)) return null;
    var drawers = config.carts.filter(function (cart) { return cart && cart.cartType === 'CART_DRAWER' && cart.isPublished === true; });
    if (drawers.length !== 1 || drawers[0].id !== cartId) return null;
    var cart = drawers[0];
    var offer = Array.isArray(cart.orderUpsells) && cart.orderUpsells.length === 1 ? cart.orderUpsells[0] : null;
    return offer && offer.id === offerId && offer.shopifyVariantId === variantId && offer.displayType === 'CART_LINE'
      && typeof offer.isEnabled === 'boolean' && cart.design && typeof cart.design === 'object' && !Array.isArray(cart.design) ? cart : null;
  }

  function cartIdentity(cart) {
    return cart && typeof cart.token === 'string' && cart.token ? cart.token.split('?')[0] : null;
  }

  function protectionLines(cart) {
    return cart.items.filter(function (item) {
      return String(item.variant_id || item.id) === '55311198814545'
        || (item.properties && item.properties.__essential_cart_drawer_order_upsell_id === offerId);
    });
  }

  function exactProtection(item) {
    return String(item.variant_id || item.id) === '55311198814545' && item.quantity === 1 && typeof item.key === 'string'
      && item.properties && item.properties.__essential_cart_drawer_order_upsell_id === offerId
      && item.properties.__essential_cart_drawer_upsell_id === cartId;
  }

  function readChoice(identity) {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(choiceKey + ':' + identity));
      return { available: true, choice: stored && stored.cart === identity ? stored.choice : null };
    } catch (_) { return { available: false, choice: null }; }
  }

  function saveChoice(identity, choice) {
    try {
      var value = JSON.stringify({ cart: identity, choice: choice });
      window.sessionStorage.setItem(choiceKey + ':' + identity, value);
      return window.sessionStorage.getItem(choiceKey + ':' + identity) === value;
    } catch (_) { return false; }
  }

  function cartApi() {
    var api = window.essentialCartApi;
    return api && typeof api.getCartData === 'function' && typeof api.removeItem === 'function' ? api : null;
  }

  function appConfigText(element, ready, attributeSource) {
    // Explicit merchant updates to the server attribute take priority for that event.
    if (attributeSource) return element.getAttribute('upsell-app-data');
    var raw;
    if (ready) {
      try { raw = element.upsellAppData; } catch (_) {}
      if (typeof raw === 'string') return raw;
      // The verified native setter reflects camelCase to this lowercase HTML attribute.
      raw = element.getAttribute('upsellappdata');
      if (typeof raw === 'string') return raw;
    }
    return element.getAttribute('upsell-app-data');
  }

  function nativeButton() {
    function unavailable(reason) {
      status.nativeGate = reason;
      return null;
    }
    var embeds = document.querySelectorAll(tag);
    if (embeds.length !== 1) return unavailable('embed-count-' + embeds.length);
    if (!nativeProperty(embeds[0])) return unavailable('native-property-missing');
    var cart;
    try { cart = eligibleCart(JSON.parse(appConfigText(embeds[0], true, false))); } catch (_) { return unavailable('embed-config-invalid-json'); }
    if (!cart) return unavailable('embed-config-ineligible');
    if (!cart.orderUpsells[0].isEnabled) return unavailable('embed-offer-disabled');
    var mirror = eligibleCart(window.essentialCartConfigs);
    if (!mirror) return unavailable('mirror-config-ineligible');
    if (!mirror.orderUpsells[0].isEnabled) return unavailable('mirror-offer-disabled');
    var buttons = document.querySelectorAll('#essential-cart-drawer-portal [data-essential-cart-element="order-upsell-item"] button[aria-pressed]');
    if (buttons.length !== 1) return unavailable('button-count-' + buttons.length);
    if (!buttons[0].isConnected) return unavailable('button-disconnected');
    status.nativeGate = 'ready';
    return buttons[0];
  }

  function inlinePriceContext(config) {
    if (assignment !== 'v2') return null;
    // C: same native description as B, price label hidden (cost is shown in checkout).
    if (!eligibleCart(config)) return null;
    var button = nativeButton();
    if (!button || typeof button.closest !== 'function') return null;
    var item = button.closest('[data-essential-cart-element="order-upsell-item"]');
    var price = button.previousElementSibling;
    var row = button.parentElement;
    if (!item || !price || price.tagName !== 'DIV' || !row || row.children.length !== 2
      || row.children[0] !== price || row.children[1] !== button || !item.contains(price)
      || price.querySelector('button,a,input,select')) return null;
    if (!/\d/.test(price.textContent)) return null;
    var amount = price.textContent.replace(/[\s\u00a0\u202f]/g, '');
    if (false && !/^(?:€2(?:[.,]00)?|2(?:[.,]00)?€)$/.test(amount)) return null;
    return { price: price };
  }

  function priceTranslations(offer) {
    var translations = JSON.parse(JSON.stringify(offer.contentTranslations || []));
    var locales = Object.keys(inlinePriceCopy);
    translations.forEach(function (entry) {
      var locale = entry.locale.toLowerCase().split(/[-_]/)[0];
      if (inlinePriceCopy[locale]) entry.content.description = inlinePriceCopy[locale];
    });
    locales.forEach(function (locale) {
      if (!translations.some(function (entry) { return entry.locale.toLowerCase() === locale; })) {
        translations.push({ locale: locale, content: { description: inlinePriceCopy[locale] } });
      }
    });
    return translations;
  }

  function untranslatedState(offer, previous) {
    var state = { present: Object.prototype.hasOwnProperty.call(offer, 'contentTranslations'), value: offer.contentTranslations };
    if (!previous || !Array.isArray(state.value)) return state;
    var original = Array.isArray(previous.value) ? previous.value : [];
    var restored = JSON.parse(JSON.stringify(state.value)).filter(function (entry) {
      var applied = previous.applied.find(function (value) { return value.locale === entry.locale; });
      if (!applied || !entry.content || entry.content.description !== applied.content.description) return true;
      var before = original.find(function (value) { return value.locale === entry.locale; });
      if (before && before.content && Object.prototype.hasOwnProperty.call(before.content, 'description')) entry.content.description = before.content.description;
      else delete entry.content.description;
      return before || Object.keys(entry.content).length > 0 || Object.keys(entry).some(function (key) { return key !== 'locale' && key !== 'content'; });
    });
    if (!restored.length && !Array.isArray(previous.value)) return { present: previous.present, value: previous.value };
    return { present: true, value: restored };
  }

  function applyPriceTranslations(offer, baseline) {
    var original = untranslatedState(offer, baseline.translations);
    var applied = priceTranslations({ contentTranslations: original.value });
    baseline.translations = { present: original.present, value: original.value, applied: applied };
    offer.contentTranslations = applied;
  }

  function restorePriceTranslations(offer, baseline) {
    if (!baseline.translations || !offer) return;
    var original = untranslatedState(offer, baseline.translations);
    if (original.present) offer.contentTranslations = original.value;
    else delete offer.contentTranslations;
    baseline.translations = null;
  }

  function descriptionVisible(node) {
    if (!node.isConnected || typeof node.getClientRects !== 'function' || typeof window.getComputedStyle !== 'function') return false;
    var rects = Array.from(node.getClientRects());
    if (!rects.some(function (rect) { return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0
      && rect.left < window.innerWidth && rect.top < window.innerHeight; })) return false;
    for (var current = node; current && current.nodeType === 1; current = current.parentElement) {
      var style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0 || style.contentVisibility === 'hidden') return false;
      if (current === node && (parseFloat(style.fontSize) <= 0 || style.color === 'transparent' || /rgba\([^)]*,\s*0(?:\.0*)?\s*\)/.test(style.color))) return false;
    }
    return true;
  }

  function restoreNativePrice() {
    if (!hiddenPrice) return;
    var style = hiddenPrice.node.style;
    if (style.getPropertyValue('display') === 'none' && style.getPropertyPriority('display') === 'important') {
      if (hiddenPrice.value) style.setProperty('display', hiddenPrice.value, hiddenPrice.priority);
      else style.removeProperty('display');
    }
    hiddenPrice = null;
  }

  function updatePricePresentation() {
    if (assignment !== 'v2') { restoreNativePrice(); return; }
    var elements = document.querySelectorAll(tag);
    if (elements.length !== 1) { restoreNativePrice(); return; }
    applyElement(elements[0], false);
    var context;
    try { context = inlinePriceContext(JSON.parse(appConfigText(elements[0], nativeProperty(elements[0]), false))); } catch (_) {}
    if (!context) { restoreNativePrice(); return; }
    if (hiddenPrice && hiddenPrice.node !== context.price) restoreNativePrice();
    if (!hiddenPrice) hiddenPrice = { node: context.price, value: context.price.style.getPropertyValue('display'), priority: context.price.style.getPropertyPriority('display') };
    if (context.price.style.getPropertyValue('display') !== 'none' || context.price.style.getPropertyPriority('display') !== 'important') context.price.style.setProperty('display', 'none', 'important');
  }

  function scheduleSelection() {
    if (selectionScheduled || (!enabledVariant(assignment) && !autoOperation)) return;
    selectionScheduled = true;
    Promise.resolve().then(function () {
      selectionScheduled = false;
      reconcileSelection();
    });
  }

  function awaitReadiness(phase) {
    status.preselection = phase;
    if (!enabledVariant(assignment) || selectionTimer !== null || readinessChecks >= 32) return;
    readinessChecks += 1;
    selectionTimer = window.setTimeout(function () {
      selectionTimer = null;
      scheduleSelection();
    }, 250);
  }

  function reconcileSelection() {
    try { reconcileSelectionState(); }
    finally { updatePricePresentation(); reportStatus(); }
  }

  function reconcileSelectionState() {
    var api = cartApi();
    if (!api) { awaitReadiness('awaiting-native-api'); return; }
    var cart;
    try { cart = api.getCartData(); } catch (_) { return; }
    var identity = cartIdentity(cart);
    if (!identity || !Array.isArray(cart.items)) { awaitReadiness('awaiting-cart'); return; }
    var lines = protectionLines(cart);
    if (autoOperation && autoOperation.cart !== identity) autoOperation = null;
    if (autoOperation && !lines.length && !autoOperation.button.disabled) autoOperation = null;
    if (autoOperation && autoOperation.cart === identity && autoOperation.cancelled && !autoOperation.removing) {
      if (lines.length === 1 && exactProtection(lines[0])) {
        var operation = autoOperation;
        operation.removing = true;
        status.preselection = 'restoring-cancelled-selection';
        Promise.resolve().then(function () { return api.removeItem(lines[0].key); }).catch(function () {
          status.preselection = 'restore-failed';
          reportStatus();
        }).finally(function () { if (autoOperation === operation) autoOperation = null; });
      }
      return;
    }
    if (!enabledVariant(assignment)) return;
    var button = nativeButton();
    if (!button) { awaitReadiness('awaiting-native-toggle'); return; }
    var stored = readChoice(identity);
    if (!stored.available) { status.preselection = 'storage-unavailable'; return; }
    // A disappearing line can be native control cleanup or another tab. It is not a customer opt-out.
    if (lastCart === identity && lastProtectionPresent && !lines.length) selectionBudgetUsed.add(identity);
    lastCart = identity;
    lastProtectionPresent = lines.length > 0;
    stored = readChoice(identity);
    if (lines.length) {
      staleSelection = null;
      selectionBudgetUsed.add(identity);
      if (!stored.choice || stored.choice === 'attempted') saveChoice(identity, 'on');
      status.preselection = lines.length === 1 && exactProtection(lines[0]) ? 'selected' : 'existing-protection';
      return;
    }
    if (stored.choice && stored.choice !== 'on') {
      status.preselection = stored.choice === 'off' ? 'opted-out' : 'already-attempted';
      return;
    }
    if (apiOperation === identity) { status.preselection = 'adding'; return; }
    var restoring = false;
    if (selectionBudgetUsed.has(identity)) {
      // Essential can remove the line on page load before this adapter enables the offer. Without a customer
      // click the choice is still 'on', so restore it once per page and cart; an explicit opt-out is 'off'.
      if (stored.choice !== 'on' || restoreBudgetUsed.has(identity)) { status.preselection = 'already-attempted'; return; }
      restoring = true;
    }
    var ordinaryItems = cart.items.some(function (item) {
      return item.quantity > 0 && !(item.properties && (item.properties.__essential_cart_drawer_order_upsell_id || item.properties.__essential_cart_drawer_reward_tier_id));
    });
    if (!ordinaryItems) { status.preselection = 'empty-cart'; return; }
    if (button.disabled) { awaitReadiness('native-toggle-busy'); return; }
    if (button.getAttribute('aria-pressed') !== 'false') {
      // Essential sets the toggle state only on mount, so after a native cleanup it can show selected without a
      // line. Once that state is confirmed after a pause, add the exact native line so cart and toggle match.
      if (!staleSelection || staleSelection.cart !== identity) {
        var stale = staleSelection = { cart: identity, ready: false };
        window.setTimeout(function () { if (staleSelection === stale) stale.ready = true; scheduleSelection(); }, 600);
      }
      if (!staleSelection.ready) { status.preselection = 'native-toggle-selected-without-line'; return; }
      staleSelection = null;
      addThroughApi(api, identity, restoring);
      return;
    }
    staleSelection = null;
    if (!saveChoice(identity, 'attempted')) { status.preselection = 'storage-unavailable'; return; }
    selectionBudgetUsed.add(identity);
    if (restoring) restoreBudgetUsed.add(identity);
    autoOperation = { cart: identity, cancelled: false, removing: false, button: button };
    status.attempts += 1;
    status.preselection = restoring ? 'restoring' : 'adding';
    automaticClick = true;
    try {
      // Essential's own handler owns the real cart write, busy state and selected state.
      button.click();
    } catch (_) { status.preselection = 'add-failed'; }
    finally { automaticClick = false; }
  }

  function addThroughApi(api, identity, restoring) {
    if (typeof api.addItem !== 'function') { status.preselection = 'api-add-unavailable'; return; }
    if (!saveChoice(identity, 'attempted')) { status.preselection = 'storage-unavailable'; return; }
    selectionBudgetUsed.add(identity);
    if (restoring) restoreBudgetUsed.add(identity);
    apiOperation = identity;
    status.attempts += 1;
    status.preselection = restoring ? 'restoring' : 'adding';
    Promise.resolve().then(function () {
      return api.addItem(55311198814545, 1, { __essential_cart_drawer_order_upsell_id: offerId, __essential_cart_drawer_upsell_id: cartId });
    }).catch(function () {
      status.preselection = 'add-failed';
    }).finally(function () {
      if (apiOperation === identity) apiOperation = null;
      scheduleSelection();
      reportStatus();
    });
  }

  function rememberNativeChoice(event) {
    if (automaticClick || (!enabledVariant(assignment) && !autoOperation)) return;
    var button = nativeButton();
    if (!button || button.disabled || !(event.target === button || button.contains(event.target))) return;
    var api = cartApi();
    var cart;
    try { cart = api && api.getCartData(); } catch (_) { return; }
    var identity = cartIdentity(cart);
    if (!identity) return;
    autoOperation = null;
    // Only this explicit native click records off. An opt-in is confirmed only after its real line arrives.
    saveChoice(identity, button.getAttribute('aria-pressed') === 'true' ? 'off' : 'attempted');
  }

  function nativeProperty(element) {
    var prototype = Object.getPrototypeOf(element);
    while (prototype) {
      var descriptor = Object.getOwnPropertyDescriptor(prototype, 'upsellAppData');
      if (descriptor) return typeof descriptor.set === 'function' && typeof descriptor.get === 'function';
      prototype = Object.getPrototypeOf(prototype);
    }
    return false;
  }

  function overrideField(object, key, value, fields) {
    var previous = fields[key];
    if (!previous || !sameValue(object[key], previous.applied)) {
      previous = { present: Object.prototype.hasOwnProperty.call(object, key), value: object[key] };
      fields[key] = previous;
    }
    previous.applied = value;
    object[key] = value;
  }

  function sameValue(first, second) {
    return first === second || (first && second && typeof first === 'object' && typeof second === 'object' && JSON.stringify(first) === JSON.stringify(second));
  }

  function restoreFields(object, fields) {
    Object.keys(fields).forEach(function (key) {
      var previous = fields[key];
      // Preserve a newer merchant value instead of restoring stale configuration.
      if (object && sameValue(object[key], previous.applied)) {
        if (previous.present) object[key] = previous.value;
        else delete object[key];
      }
      delete fields[key];
    });
  }

  function footerProtectionOrder(cart, offer) {
    var content = cart.content;
    if (!content || typeof content !== 'object' || Array.isArray(content)
      || !Array.isArray(content.featuresOrder) || typeof offer.stableId !== 'string' || !offer.stableId) return null;
    var order = content.featuresOrder;
    if (!order.every(function (entry) { return typeof entry === 'string'; })) return null;
    var token = 'ORDER_UPSELL:' + offer.stableId;
    if ([token, 'DISCOUNTS', 'SUBTOTAL', '__FOOTER_DIVIDER__'].some(function (anchor) {
      return order.filter(function (entry) { return entry === anchor; }).length !== 1;
    })) return null;
    if (order.indexOf('__FOOTER_DIVIDER__') > order.indexOf('DISCOUNTS')
      || order.indexOf('DISCOUNTS') > order.indexOf('SUBTOTAL')) return null;
    var next = order.filter(function (entry) { return entry !== token; });
    next.splice(next.indexOf('DISCOUNTS'), 0, token);
    return next;
  }

  function stickyCarts(config) {
    return config.carts.filter(function (cart) {
      return cart && cart.cartType === 'STICKY_ADD_TO_CART' && typeof cart.id === 'string' && Array.isArray(cart.orderUpsells);
    });
  }

  // Essential removes an order-upsell cart line in every mounted cart component whose own offers do not
  // include that line's enabled offer. The product-page sticky add-to-cart only knows its own disabled
  // offer, so without this it removes the protection line on product pages.
  function syncStickyOffers(config, offer, baseline, enabled) {
    stickyCarts(config).forEach(function (cart) {
      var fields = baseline.sticky[cart.id] || (baseline.sticky[cart.id] = {});
      if (!enabled) { restoreFields(cart, fields); return; }
      var next = cart.orderUpsells.filter(function (entry) { return !entry || entry.id !== offerId; })
        .concat([JSON.parse(JSON.stringify(offer))]);
      overrideField(cart, 'orderUpsells', next, fields);
    });
  }

  function restoreStickyOffers(config, baseline) {
    stickyCarts(config).forEach(function (cart) {
      if (baseline.sticky && baseline.sticky[cart.id]) restoreFields(cart, baseline.sticky[cart.id]);
    });
    baseline.sticky = {};
  }

  function applyElement(element, attributeSource) {
    if ((!assignment && !configBaselines.has(element)) || !element.isConnected || !element.matches(tag)) return;
    var ready = nativeProperty(element);
    var raw = appConfigText(element, ready, attributeSource);
    var config;
    try {
      config = JSON.parse(raw);
    } catch (error) {
      status.phase = 'invalid-config';
      return;
    }
    if (!config || !Array.isArray(config.carts)) return;
    var carts = config.carts.filter(function (cart) {
      return cart && cart.id === cartId && cart.cartType === 'CART_DRAWER';
    });
    if (carts.length !== 1 || !Array.isArray(carts[0].orderUpsells)) {
      status.phase = 'unmatched-cart';
      return;
    }
    var offers = carts[0].orderUpsells.filter(function (offer) {
      return offer && offer.id === offerId;
    });
    var offer = offers.length === 1 && offers[0].shopifyVariantId === variantId
      && offers[0].displayType === 'CART_LINE' && typeof offers[0].isEnabled === 'boolean' ? offers[0] : null;
    var design = carts[0].design;
    var validDesign = design && typeof design === 'object' && !Array.isArray(design);
    var eligible = eligibleCart(config);
    if (!ready && window.customElements && window.customElements.get(tag)) {
      status.phase = 'unsupported-contract';
      return;
    }
    var before = JSON.stringify(config);
    var baseline = configBaselines.get(element);
    if (!assignment || !eligible) {
      if (autoOperation) autoOperation.cancelled = true;
      status.phase = !assignment ? 'unassigned' : !offer ? 'unmatched-offer'
        : !validDesign ? 'unsupported-price-config' : 'unmatched-cart';
      if (!baseline) return;
      restoreFields(offer, baseline.offer);
      restoreFields(offer, baseline.presentation);
      restorePriceTranslations(offer, baseline);
      restoreFields(validDesign ? design : null, baseline.design);
      restoreFields(carts[0].content, baseline.content);
      restoreStickyOffers(config, baseline);
      configBaselines.delete(element);
    } else {
      status.phase = ready ? 'applied' : 'awaiting-upgrade';
      if (!baseline) {
        baseline = { offer: {}, design: {}, content: {}, presentation: {}, translations: null, sticky: {} };
        configBaselines.set(element, baseline);
      }
      var enabled = enabledVariant(assignment);
      if (!enabled) restoreFields(offer, baseline.offer);
      overrideField(offer, 'isEnabled', enabled, baseline.offer);
      if (enabled) {
        overrideField(offer, 'autoRemoveWhenCartEmpty', true, baseline.offer);
        overrideField(design, 'orderUpsellPriceFontSize', 14, baseline.design);
        overrideField(design, 'orderUpsellDescriptionFontSize', 15, baseline.design);
      } else restoreFields(design, baseline.design);
      var footerOrder = assignment === 'v2' ? footerProtectionOrder(carts[0], offer) : null;
      if (footerOrder) overrideField(carts[0].content, 'featuresOrder', footerOrder, baseline.content);
      else restoreFields(carts[0].content, baseline.content);
      // Keep the native (B) description in every variant.
      restoreFields(offer, baseline.presentation);
      restorePriceTranslations(offer, baseline);
      syncStickyOffers(config, offer, baseline, enabled);
    }
    var next = JSON.stringify(config);
    try {
      if (before === next && !(ready && attributeSource && appConfigText(element, ready, false) !== next)) return;
      if (ready) {
        element.upsellAppData = next;
      } else {
        element.setAttribute('upsell-app-data', next);
      }
      status.writes += 1;
    } catch (error) {
      status.phase = 'write-failed';
    }
  }

  function scan() {
    document.querySelectorAll(tag).forEach(function (element) { applyElement(element, false); });
    updatePricePresentation();
    scheduleSelection();
    reportStatus();
  }

  function start() {
    if (initialized) return;
    initialized = true;
    status.phase = 'awaiting-embed';
    observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          if (record.attributeName === 'upsell-app-data' || record.attributeName === 'upsellappdata') applyElement(record.target, record.attributeName === 'upsell-app-data');
          return;
        }
        if (record.type !== 'childList') return;
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(tag)) applyElement(node, false);
          node.querySelectorAll(tag).forEach(function (element) { applyElement(element, false); });
        });
      });
      scheduleSelection();
      reportStatus();
    });
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['upsell-app-data', 'upsellappdata', 'aria-pressed', 'disabled', 'lang', 'style', 'class', 'hidden']
    });
    if (window.customElements) window.customElements.whenDefined(tag).then(scan);
    document.addEventListener('DOMContentLoaded', scan, { once: true });
    document.addEventListener('click', rememberNativeChoice, true);
    document.addEventListener('essential-cart:update', scheduleSelection);
    document.addEventListener('essential-cart:open', scheduleSelection);
    window.addEventListener('pageshow', scan);
    window.addEventListener('resize', scheduleSelection);
  }

  window.igShippingProtectionApplyVariant = function (variant) {
    if (!valid(variant) && variant !== null) return;
    var previousAssignment = assignment;
    assignment = variant;
    if (assignment === 'control') {
      autoOperation = null;
      lastCart = null;
      lastProtectionPresent = false;
    }
    else if (!enabledVariant(assignment) && autoOperation) autoOperation.cancelled = true;
    if (enabledVariant(assignment) && previousAssignment === 'control') { selectionBudgetUsed.clear(); restoreBudgetUsed.clear(); }
    if (!enabledVariant(assignment)) status.preselection = 'inactive';
    if (selectionTimer !== null) { window.clearTimeout(selectionTimer); selectionTimer = null; }
    staleSelection = null;
    readinessChecks = 0;
    window.__igShippingProtectionVariant = variant;
    status.variant = variant;
    if (assignment) start();
    else status.phase = 'unassigned';
    scan();
  };

  var pending = window.__igShippingProtectionVariant;
  if (!valid(pending) && pending !== null) {
    try {
      if (previewMode) {
        var preview = new URLSearchParams(window.location.search).get('cdxtest');
        if (preview === 'shipping-on') pending = 'v1';
        if (preview === 'shipping-inline') pending = 'v2';
        if (preview === 'shipping-off') pending = 'control';
      }
    } catch (error) {}
  }
  if (valid(pending)) window.igShippingProtectionApplyVariant(pending);
  else reportStatus();
})();
